import Backdrop from '@mui/material/Backdrop';
import { LoadingSpinner } from '@src/common/components/LoadingSpinner';

export const LoadingOverlay = () => {
  return (
    <Backdrop
      sx={(theme) => ({
        bgcolor: 'rgba(255, 255, 255, 0.65)',
        zIndex: theme.zIndex.drawer + 1,
      })}
      open
    >
      <LoadingSpinner />
    </Backdrop>
  );
};
